import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProductPrice from 'components/ProductPrice';

const StyledUsageAndPrice = styled.h2`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    ${({ smallPrice }) => (smallPrice ? `
    .ProductPrice {
      font-size:0.7em;
    }
    ` : '')}
`;

const UsageAndPrice = ({ className, usage, price }) => {
  const classes = ['UsageAndPrice', className];

  return (
    <StyledUsageAndPrice
      className={classes.filter((c) => !!c).join(' ')}
      smallPrice={price.small}
    >
      {usage}
      <ProductPrice
        price={price.price}
        currency={price.currency}
        frequency={price.frequency}
      />
    </StyledUsageAndPrice>
  );
};

UsageAndPrice.displayName = 'UsageAndPrice';

UsageAndPrice.propTypes = {
  className: PropTypes.string,
  usage: PropTypes.string.isRequired,
  price: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    frequency: PropTypes.string.isRequired,
    small: PropTypes.bool,
  }).isRequired,
};

UsageAndPrice.defaultProps = {
  className: null,
};

export default UsageAndPrice;
